/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

// tslint:disable:no-non-null-assertion

import { ConversionRatesDto } from '@gh/builder-shared-data';

export type ConversionRates = ConversionRatesDto;
export type ConversionRatesItem = {
  lblCol1: string;
  count: number;
  lblCol2?: string;
  lastYear?: number;
  total?: number;
};

export const conversionRatesFromDto = (dto: ConversionRatesDto): ConversionRatesItem[] => {
  const items: ConversionRatesItem[] = [];

  items.push({
    lblCol1: 'lbl_leads',
    count: dto.leads || 0,
    lblCol2: 'lbl_lead_to_sale',
    lastYear: dto.leadsToSales || 0,
    total: dto.leadsToSalesTotal || 0,
  });

  items.push({
    lblCol1: 'lbl_quotes',
    count: dto.quotes || 0,
    lblCol2: 'lbl_quote_to_sale',
    lastYear: dto.quotesToSales || 0,
    total: dto.quotesToSalesTotal || 0,
  });

  items.push({
    lblCol1: 'lbl_sales',
    count: dto.sales || 0,
    lblCol2: 'lbl_lead_to_slab',
    lastYear: dto.leadsToSlabs || 0,
    total: dto.leadsToSlabsTotal || 0,
  });

  items.push({
    lblCol1: 'lbl_slab',
    count: dto.slabs || 0,
  });

  return items;
};
